import { render, staticRenderFns } from "./NewSOA.vue?vue&type=template&id=3ed54c96&"
import script from "./NewSOA.vue?vue&type=script&lang=js&"
export * from "./NewSOA.vue?vue&type=script&lang=js&"
import style0 from "./NewSOA.vue?vue&type=style&index=0&id=3ed54c96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports